import { render } from "./CNotFound.vue?vue&type=template&id=70d04dd4"
import script from "./CNotFound.vue?vue&type=script&lang=js"
export * from "./CNotFound.vue?vue&type=script&lang=js"

import "./CNotFound.vue?vue&type=style&index=0&id=70d04dd4&lang=scss"

import exportComponent from "/Users/tung/Documents/GitHub/cc-faq/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__